import * as React from 'react';

const RVULogo = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 250 28.767" {...props}>
    <defs>
      <clipPath id="a">
        <rect className="a" width="100" height="28.767" transform="translate(0 0.004)"></rect>
      </clipPath>
    </defs>
    <g transform="translate(0 -0.004)">
      <g className="b">
        <path
          className="fill-[white]"
          d="M99.909,1.342A1.4,1.4,0,0,0,98.5.006H86.468a1.407,1.407,0,0,0-1.412,1.4,65.976,65.976,0,0,1-.578,7.575,40.066,40.066,0,0,1-2.81,10.879,11.378,11.378,0,0,1-4.254,5.326,6.357,6.357,0,0,1-6.121.012C65.445,21.814,64.11,9.767,63.956,2.812h9.365c.2,5.393,1.3,11.661,3.986,16.2a.715.715,0,0,0,1.29-.588c-.228-.686-.44-1.372-.628-2.068-.372-1.386-.656-2.792-.9-4.206a79.773,79.773,0,0,1-.926-9.683l-.034-1.058v-.07A1.388,1.388,0,0,0,74.7.008H62.516a1.4,1.4,0,0,0-1.4,1.374c-.014,1.36.034,2.652.108,4,.35,5.319,1.082,10.7,3.232,15.662a13.6,13.6,0,0,0,5.459,6.6,9.277,9.277,0,0,0,6.745.85,10.153,10.153,0,0,0,5.458-3.849C86,19.353,87.126,11.772,87.688,5.407c.066-.874.118-1.728.15-2.594h9.233c-.014.9-.042,1.806-.082,2.678-.324,5.879-1.176,18.5-7.7,20.676a8.032,8.032,0,0,1-3.678.222.738.738,0,0,0-.368,1.426c5.1,1.666,9.115-1.136,11.353-5.6,3-6,3.672-14.251,3.308-20.872Z"
        ></path>
        <path
          className="fill-[white]"
          d="M52.432,0,42.69,22.2,33.037,0H27.19L38.773,26.277a4.137,4.137,0,0,0,3.16,2.452,4.06,4.06,0,0,0,4.306-2.37L57.82,0Z"
        ></path>
        <path
          className="fill-[white]"
          d="M22.692,15.826a9.682,9.682,0,0,0,1.6-5.589A9.7,9.7,0,0,0,22.8,4.772a9.529,9.529,0,0,0-4.29-3.534A16.155,16.155,0,0,0,11.937,0H1.6A1.6,1.6,0,0,0,0,1.592V28.771H5.572V4.526h6.114A8.329,8.329,0,0,1,17.033,6a5.137,5.137,0,0,1,1.824,4.234,5.2,5.2,0,0,1-1.824,4.254,8.328,8.328,0,0,1-4.65,1.434c-.012,0-.024.006-.038.006l-1.846-.01a.914.914,0,0,0-.76,1.438l1.03,1.458a1.788,1.788,0,0,0,.212.3l.03.042.358.508v-.01l6.608,9.117h6.03l-6.672-9.451c1.99-.766,4.288-1.932,5.352-3.494Z"
        ></path>
      </g>
    </g>
  </svg>
);

export default RVULogo;
